import { render, staticRenderFns } from "./CodeVerificationForm.vue?vue&type=template&id=0e8c9f4f&scoped=true&"
import script from "./CodeVerificationForm.vue?vue&type=script&lang=js&"
export * from "./CodeVerificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8c9f4f",
  null
  
)

export default component.exports